import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Typography,
  Container,
  Box,
  Avatar,
  useTheme,
} from '@mui/material';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../../Atoms';

const DataBox = function DataBox({
  widget = null,
  title = null,
  icon = null,
  color = null,
  flex = null,
  padding = '16px',
  centered = false,
}) {
  const theme = useTheme();
  const currentTheme = useAtomValue(themeAtom);
  return (
    <Paper
      sx={{
        flex,
        display: 'flex',
        borderRadius: '26px',
        height: '100%',
        width: '100%',
        boxShadow: '0px 11px 15px rgba(0, 0, 0, 0.21)',
      }}
    >
      <Container
        maxWidth="false"
        sx={{ p: '24px 32px', margin: 'unset', height: 'inherit' }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 3
          }}>
          {icon && (
            <Avatar
              sx={{
                width: '60px',
                height: '60px',
                position: 'inherit',
                ...theme.custom.bgAndColorStyle(color, currentTheme),
              }}
            >
              {icon}
            </Avatar>
          )}
          <Typography
            variant="h6"
            sx={{ fontSize: '1.5rem', textOverflow: 'ellipsis' }}
            noWrap
            title={title}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            padding: padding,
            width: "100%",
            height: "100%",
            display: centered ? 'flex' : 'block',
            alignItems: centered ? 'center' : 'flex-start',
            justifyContent: centered ? 'center' : 'flex-start'
          }}>
          {widget} {/* Content of Paper */}
        </Box>
      </Container>
    </Paper>
  );
};

DataBox.propTypes = {
  flex: PropTypes.string,
  widget: PropTypes.object,
  title: PropTypes.string,
  icon: PropTypes.object,
  color: PropTypes.string,
};

export default DataBox;
